<template>
  <div class="container">
    <div class="msg">{{status.msg}}</div>
    <div class="home">
      <router-link tag="a" to="/index">返回首页</router-link>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters({
      status: 'status'
    })
  },
  created() {
    console.log('发生错误')
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .container{
    padding: size(30)
    color: #222;
    .msg{
      font-size: size(32)
      text-align center
      padding: size(40)
    }
    .home{
      text-align center
      a{
        display inline-block
        font-size size(28)
        color: #222
        padding: size(15) size(30)
        border: 1px solid #ccc;
        -webkit-border-radius: size(10)
        -moz-border-radius: size(10)
        border-radius: size(10)
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/error/error.vue